import styled, { keyframes } from 'styled-components'

import { style } from 'theme'

const fadeout = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`

export const DesktopFootnote = styled.p`
  font-size: 12px;
  font-style: italic;
  line-height: 16px;
  text-align: center;
  color: ${style(theme => theme.colors.stone)};
  animation: ${fadeout} 0.3s;
  animation-delay: 6s;
  animation-fill-mode: forwards;
  margin: 0;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const AnalyzingContainer = styled.div`
  position: absolute;
  top: 58%;
  left: 50.8%;
  transform: translateX(-50%);
  animation: ${fadeout} 0.3s;
  animation-delay: 4.4s;
  animation-fill-mode: forwards;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    top: 54%;
    left: 52%;
  }
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    top: 51%;
    left: 52%;
  }
`

export const AnimationContainer = styled.div`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`
